import React from "react";
import About from "./about";
import Contact from "./contact";
import Banner from "./banner";
import Cases from "./cases";

const Home = () => {
  return (
    <div>
      <Banner />
      <Cases />
      <About />
      <Contact />
    </div>
  );
};

export default Home;
